var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookDarkBlackThickIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V11.2C0 12.0745 0.72555 12.8 1.6 12.8H6.87031C6.95293 13.0337 7.10589 13.2361 7.30818 13.3793C7.51046 13.5226 7.75213 13.5997 8 13.6C8.24787 13.5997 8.48954 13.5226 8.69182 13.3793C8.89411 13.2361 9.04707 13.0337 9.12969 12.8H14.4C15.2745 12.8 16 12.0745 16 11.2V0H10.4C9.43125 0 8.58844 0.460997 8 1.14844C7.41156 0.460997 6.56875 0 5.6 0H0ZM1.6 1.6H5.6C6.49333 1.6 7.2 2.30667 7.2 3.2H8.8C8.8 2.30667 9.50667 1.6 10.4 1.6H14.4V11.2H1.6V1.6ZM10.4 4V5.6H12V4H10.4ZM10.4 6.4V9.6H12V6.4H10.4Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDarkBlackThickIcon);
export default __webpack_public_path__ + "static/media/book-dark-black-thick-icon.8d8a4b1308cbc813ea978e6eea59acb5.svg";
export { ForwardRef as ReactComponent };